import React, { useEffect } from "react";

const TOTAL_IMGS = 274;

const createArray = (num) => {
  let arr = [];
  for (let i = 0; i < num; i++) {
    arr.push(i);
  }
  arr = shuffle(arr);

  return [...arr, ...arr];
};

const shuffle = (arr) => {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
};

function App() {
  useEffect(() => {
    startScroll(1);
    startScroll(2, false);
    startScroll(3);
    startScroll(4, false);
    startScroll(5);
    startScroll(6, false);
    startScroll(7);
    startScroll(8, false);
  }, []);

  const speeds = [1, 1, 1, 1, 1, 1, 1, 1];

  const startScroll = (classCount, reverse = true) => {
    let doc = window.document,
      context = doc.querySelector(`.corusal${classCount}`),
      clones = context.querySelectorAll(`.is-clone`),
      disableScroll = false,
      scrollHeight = 0,
      scrollPos = 0,
      clonesHeight = 0,
      i = 0;

    function getScrollPos() {
      return (
        (context.pageYOffset || context.scrollTop) - (context.clientTop || 0)
      );
    }

    function setScrollPos(pos) {
      context.scrollTop = pos;
    }

    function getClonesHeight() {
      clonesHeight = 0;

      for (i = 0; i < clones.length; i += 1) {
        clonesHeight = clonesHeight + clones[i].offsetHeight;
      }

      return clonesHeight;
    }

    function reCalc() {
      scrollPos = getScrollPos();
      scrollHeight = context.scrollHeight;
      clonesHeight = getClonesHeight();

      if (scrollPos <= 0) {
        setScrollPos(1); // Scroll 1 pixel to allow upwards scrolling
      }
    }

    function scrollUpdate() {
      if (!disableScroll) {
        scrollPos = getScrollPos();
        console.log(scrollPos);
        if (clonesHeight + scrollPos >= scrollHeight) {
          // Scroll to the top when you’ve reached the bottom
          setScrollPos(1); // Scroll down 1 pixel to allow upwards scrolling
          disableScroll = true;
        } else if (scrollPos <= 0) {
          // Scroll to the bottom when you reach the top
          setScrollPos(scrollHeight - clonesHeight);
          disableScroll = true;
        }
      }

      if (disableScroll) {
        // Disable scroll-jumping for a short time to avoid flickering
        window.setTimeout(function () {
          disableScroll = false;
        }, 40);
      }
    }

    window.requestAnimationFrame(reCalc);

    context.addEventListener(
      "scroll",
      function () {
        window.requestAnimationFrame(scrollUpdate);
      },
      false
    );

    window.addEventListener(
      "resize",
      function () {
        window.requestAnimationFrame(reCalc);
      },
      false
    );

    window.onload = function () {
      setScrollPos(
        Math.round(
          clones[0].getBoundingClientRect().top +
            getScrollPos() -
            (context.offsetHeight - clones[0].offsetHeight) / 2
        )
      );
    };

    function autoScroll() {
      setTimeout(() => {
        if (scrollPos > -1) {
          if (reverse) setScrollPos(getScrollPos() - speeds[classCount - 1]);
          else setScrollPos(getScrollPos() + speeds[classCount - 1]);
        }

        window.requestAnimationFrame(autoScroll);
      }, 40);
    }

    autoScroll();
  };

  return (
    <>
      <div className="header">
        <div className="nbxTxt">
          #nimblebox
          <span className="artwallText">#artwall #project</span>
        </div>
        <div className="systemTxt">
          <div className="icon"></div>
          system online
        </div>
      </div>

      <div
        className="crousal noScrollBar"
        style={{
          pointerEvents: "none",
        }}
      >
        <div className="corusal1 noScrollBar">
          {createArray(TOTAL_IMGS)?.map((val, i) => (
            <div key={i} className="corusalImg">
              <img
                src={`/assets/${val.toString().padStart(4, "0")}.png`}
                height="195"
                width="195"
              />
            </div>
          ))}
        </div>
        <div className="corusal2 noScrollBar">
          {createArray(TOTAL_IMGS)?.map((val, i) => (
            <div key={i} className="corusalImg">
              <img
                src={`/assets/${val.toString().padStart(4, "0")}.png`}
                height="260"
                width="260"
              />
            </div>
          ))}
        </div>
        <div className="corusal3 noScrollBar">
          {createArray(TOTAL_IMGS)?.map((val, i) => (
            <div key={i} className="corusalImg">
              <img
                src={`/assets/${val.toString().padStart(4, "0")}.png`}
                height="216"
                width="216"
              />
            </div>
          ))}
        </div>
        <div className="corusal4 noScrollBar">
          {createArray(TOTAL_IMGS)?.map((val, i) => (
            <div key={i} className="corusalImg">
              <img
                src={`/assets/${val.toString().padStart(4, "0")}.png`}
                height="294"
                width="294"
              />
            </div>
          ))}
        </div>
        <div className="corusal5 noScrollBar">
          {createArray(TOTAL_IMGS)?.map((val, i) => (
            <div key={i} className="corusalImg">
              <img
                src={`/assets/${val.toString().padStart(4, "0")}.png`}
                height="241"
                width="241"
              />
            </div>
          ))}
        </div>
        <div className="corusal6 noScrollBar">
          {createArray(TOTAL_IMGS)?.map((val, i) => (
            <div key={i} className="corusalImg">
              <img
                src={`/assets/${val.toString().padStart(4, "0")}.png`}
                height="195"
                width="195"
              />
            </div>
          ))}
        </div>
        <div className="corusal7 noScrollBar">
          {createArray(TOTAL_IMGS)?.map((val, i) => (
            <div key={i} className="corusalImg">
              <img
                src={`/assets/${val.toString().padStart(4, "0")}.png`}
                height="216"
                width="216"
              />
            </div>
          ))}
        </div>
        <div className="corusal8 noScrollBar">
          {createArray(TOTAL_IMGS)?.map((val, i) => (
            <div key={i} className="corusalImg">
              <img
                src={`/assets/${val.toString().padStart(4, "0")}.png`}
                height="260"
                width="260"
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default App;
